import { useTranslation } from "@refinedev/core";
import { InputTypeIcon } from "components/customIcons";
import { DropdownMenu } from "components/dropdownMenu";
import { InputType } from "interfaces";

export const InputTypeDropdown = ({
  value,
  disabled,
  onChange,
}: {
  value: InputType;
  disabled: boolean;
  onChange: (data: string) => void;
}) => {
  const { translate } = useTranslation();

  const INPUT_TYPES = [
    {
      key: InputType.TEXT,
      label: translate("inputType.text"),
      icon: <InputTypeIcon type={InputType.TEXT} />,
    },
    {
      key: InputType.NUMBER,
      label: translate("inputType.number"),
      icon: <InputTypeIcon type={InputType.NUMBER} />,
    },
    {
      key: InputType.DATE,
      label: translate("inputType.date"),
      icon: <InputTypeIcon type={InputType.DATE} />,
    },
    {
      key: InputType.DATETIME,
      label: translate("inputType.dateAndTime"),
      icon: <InputTypeIcon type={InputType.DATETIME} />,
    },
    {
      key: InputType.SELECT,
      label: translate("inputType.singleSelect"),
      icon: <InputTypeIcon type={InputType.SELECT} />,
    },
    {
      key: InputType.MULTI_SELECT,
      label: translate("inputType.multiSelect"),
      icon: <InputTypeIcon type={InputType.MULTI_SELECT} />,
    },
    {
      key: InputType.CHECKBOX,
      label: translate("inputType.checkbox"),
      icon: <InputTypeIcon type={InputType.CHECKBOX} />,
    },
    {
      key: InputType.RADIO_BUTTON,
      label: translate("inputType.radioButton"),
      icon: <InputTypeIcon type={InputType.RADIO_BUTTON} />,
    },
  ];
  return !disabled ? (
    <DropdownMenu
      position="bottom-start"
      align="left"
      label={
        <div className="w-fit flex items-center gap-x-2 px-4 py-2 border border-gray-300 rounded-lg">
          <InputTypeIcon type={value} />{" "}
          {INPUT_TYPES.find((type) => type.key === value)?.label}
        </div>
      }
      items={INPUT_TYPES.map((type) => ({
        label: type.label,
        icon: type.icon,
        onClick: () => onChange(type.key),
      }))}
    />
  ) : (
    <div className="w-fit flex items-center gap-x-2 px-4 py-2 border border-gray-300 rounded-lg select-none">
      <InputTypeIcon type={value} />{" "}
      {INPUT_TYPES.find((type) => type.key === value)?.label}
    </div>
  );
};
